import React from 'react';
import * as C from "../componentsM/index"

const InternationMindedness = () => {
    return (
        <>


            <C.Hero title={"INTERNATIONAL MINDEDNESS"}
                image={"/hero/history.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <p>In a world where global differences lead to misunderstandings and conflict, it is crucial that students connect with others on both national and international levels in order to understand and appreciate that “other people, with their differences can also be right.” (IB mission statement)</p>




                    <p>Students, teachers, and leaders in the IB school communities have a range of perspectives, values, and traditions. The concept of international-mindedness builds on these diverse perspectives to generate a sense of common humanity and shared guardianship of the planet. Hence, international- mindedness lays the foundation for students to become successful global citizens.</p>

                    <p>At The International School, international-mindedness is deeply embedded in the curriculum, enhanced further by promotion of the attributes of the Learner Profile.</p>
                    <p>The IB Community Blog, IB Mission Statement</p>


                </div>



            </section>

        </>
    )
}

export default InternationMindedness